import React, { useEffect, useState } from 'react';
import JustifyInventoryOutput from '../../components/Items/JustifyInventoryOutput';
import ConfirmModal from '../../components/Common/ConfirmModal';
import {  Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import {  toast } from 'react-toastify';
import { getAll } from '../../services/Users/Users';
import { getItem } from '../../services/Items/Inventory';
import { getCategories } from '../../services/Configs/ItemCategoriesService';
import { getLocations } from '../../services/Configs/LocationsService';
import { getStatuses } from '../../services/Other/GeneralQueries';
import { getAllSubCategories } from '../../services/Configs/ItemSubCategoriesService';
import { serviceUpdateItem } from '../../services/Items/AddItem';
import { uploadItemFiles, getItemAttachments, deleteAttachment } from '../../services/Items/UploadFiles';
import { useNavigate, useParams } from 'react-router-dom';

const getDate = () => new Date().toISOString().slice(0, 10);
const getUserId = () => sessionStorage.getItem('userId') ?? 0;
function AddItem(){ 
    const navigate = useNavigate();
    const { id } = useParams();
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [locations, setLocations] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [users, setUsers] = useState([]);
    const [oldQty, setOldQty] = useState(0);
    const [differenceInQuantity, setDifferenceInQuantity] = useState(0);
    const [showJustifyModal, setShowJustifyModal] = useState(false);    
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedLocations, setSelectedLocations] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [justifyBy, setJustifyBy] = useState('');
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    
    // Estados para manejo de archivos
    const [existingFiles, setExistingFiles] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [isLoadingFiles, setIsLoadingFiles] = useState(false);
    
    // Estados para modal de confirmación de eliminación
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [fileToDelete, setFileToDelete] = useState({ id: null, name: '' });
    
    // Tipos MIME permitidos para archivos
    const allowedFileTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'image/webp',
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    
    const [formData, setFormData] = useState({
        id: 0,
        name: '',
        description: '',
        categoryId: 0,
        subcategoryId: 0,
        quantity: '1',
        unitPrice: '0',
        locationId: 0,
        barcode: '',
        tag: '',
        statusId: 0,
        brand: '',
        model: '',
        additionalNotes: '',
        dimensions: '',
        weight: '',
        unitOfWeightMeasurement: '',
        acquisitionDate: getDate(),
        userId: getUserId(),
        serialNumber: '',
        partNumber: '',
        assignedToUserId: 0,
        differenceInQuantity: 0,
        selectedStatuses: [],
        selectedLocations: [],
        selectedUsers: [],
    });
    
    // Función para cargar archivos existentes
    const loadExistingFiles = async () => {
        setIsLoadingFiles(true);
        const files = await getItemAttachments(id);
        console.log("loadExistingFiles.files", files)
        setExistingFiles(files);
        setIsLoadingFiles(false);
    };
    
    // Función para manejar selección de nuevos archivos
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        
        // Validar tipos de archivo
        const invalidFiles = files.filter(file => !allowedFileTypes.includes(file.type));
        
        if (invalidFiles.length > 0) {
            toast.error('Algunos archivos tienen formatos no permitidos');
            return;
        }
        
        setSelectedFiles(files);
    };
    
    // Función para eliminar archivo existente
    const handleDeleteFile = (fileId, fileName) => {
        setFileToDelete({ id: fileId, name: fileName });
        setShowDeleteModal(true);
    };
    
    const confirmDeleteFile = async () => {
        const result = await deleteAttachment(fileToDelete.id);
        if (result.result) {
            toast.success('Archivo eliminado correctamente');
            loadExistingFiles();
        } else {
            toast.error('Error al eliminar el archivo');
        }
        setShowDeleteModal(false);
        setFileToDelete({ id: null, name: '' });
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();  
        console.log(formData)
        let pendingInputs = [];
        if(!formData.name)
        {
            pendingInputs.push("Nombre");
        }
        if(!formData.name)
        {
            pendingInputs.push("Nombre");
        }
        if(formData.categoryId == 0 || formData.categoryId == '0')
        {
            pendingInputs.push("Categoría");
        }
        if(!formData.quantity)
        {
            pendingInputs.push("Cantidad de objetos");
        }       
        if(formData.locationId == 0 || formData.locationId == '0')
        {
            pendingInputs.push("Ubicación");
        }
        if(formData.statusId == 0 || formData.statusId == '0')
        {
            pendingInputs.push("Estatus");
        }
        if(formData.weight)
        {
            if(!formData.unitOfWeightMeasurement)
            {
                pendingInputs.push("Unidad de medida")
            }
        }
        if(oldQty > formData.quantity)
        {
            setDifferenceInQuantity(oldQty - formData.quantity);
            pendingInputs.push("Es necesario justificar la salida");
            setShowJustifyModal(true)
        }
        if(pendingInputs.length == 0)
        {
            serviceUpdateItem(formData).then(addItemResult => {
                if(addItemResult.result)
                {
                    // Si hay nuevos archivos seleccionados, subirlos
                    if(selectedFiles.length > 0)
                    {
                        uploadItemFiles(id, selectedFiles).then(uploadResult => {
                            if(uploadResult.result)
                            {
                                toast.success('Se actualizó correctamente el objeto con sus archivos');
                            }
                            else
                            {
                                toast.warning('El objeto se actualizó pero hubo un error al subir los archivos');
                            }
                            
                            setTimeout(() => {
                                navigate('/Inventory'); 
                            }, 1500);
                        }).catch(error => {
                            toast.warning('El objeto se actualizó pero hubo un error al subir los archivos');
                            setTimeout(() => {
                                navigate('/Inventory'); 
                            }, 1500);
                        });
                    }
                    else
                    {
                        // No hay archivos nuevos, solo mostrar éxito y redirigir
                        toast.success('Se actualizó correctamente');
                        setTimeout(() => {
                            navigate('/Inventory'); 
                        }, 1500);
                    }
                }
                else
                {
                    toast.error('Error al actualizar el objeto');
                }
            });
        }
        else
        {
            toast.warning(`Lo sentimos, debes completar los siguientes campos: ${pendingInputs.join(', ')}`)
        }

    }
    const redirectBack = () => {
        navigate('/Inventory');
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value,
        });
        if(name === "categoryId")
        {
            if(parseInt(value) === 0)
            {
                setSubCategories([]);
            }
            else
            {
                getAllSubCategories(parseInt(value)).then(subList => {
                    setSubCategories(subList);
                })
            }
        }
    };
    const handleSaveFromModal = () => {
        if (justifyBy === "byGroup") {
            if (selectedStatuses.length === 0 || selectedLocations.length === 0) {
                if (selectedStatuses.length === 0) {
                    toast.warning(`Debes seleccionar el nuevo estatus`);
                }
                if (selectedLocations.length === 0) {
                    toast.warning(`Debes seleccionar la nueva ubicación`);
                }
            } else {      
                setIsSaveDisabled(true);                                          
                const updatedFormData = {
                    ...formData,
                    differenceInQuantity,
                    selectedStatuses,
                    selectedLocations,
                    selectedUsers,
                };                    
                setFormData(updatedFormData);                                
                serviceUpdateItem(updatedFormData).then((addItemResult) => {
                    toast.success('Se actualizó correctamente');
                    setTimeout(() => {
                        navigate('/Inventory'); // Redirigir después de 3 segundos
                    }, 1500);
                });
            }
        } else if (justifyBy === "byIndividual") {
            if (selectedStatuses.length !== differenceInQuantity || selectedLocations.length !== differenceInQuantity) {
                if (selectedStatuses.length !== differenceInQuantity) {
                    toast.warning(`Debes seleccionar el nuevo estatus para cada objeto`);
                }
                if (selectedLocations.length !== differenceInQuantity) {
                    toast.warning(`Debes seleccionar la nueva ubicación para cada objeto`);
                }
            } else {
                setIsSaveDisabled(true);
                const updatedFormData = {
                    ...formData,
                    differenceInQuantity,
                    selectedStatuses,
                    selectedLocations,
                    selectedUsers,
                };                
                setFormData(updatedFormData);                                
                serviceUpdateItem(updatedFormData).then((addItemResult) => {
                    toast.success('Se actualizó correctamente');
                    setTimeout(() => {
                        navigate('/Inventory'); // Redirigir después de 3 segundos
                    }, 1500);
                });
            }
        }
    
        console.log({ selectedStatuses, selectedLocations, selectedUsers });
    };
    useEffect(() => {
        getCategories().then(list=>{
            setCategories(list);
        });
        getLocations().then(list=>{
            setLocations(list);
        });
        getStatuses().then(list=>{
            setStatuses(list);
        });
        getAll().then(list=> {
            setUsers(list);
        });
        getItem(id).then(data=>{
            getAllSubCategories(data.categoryId).then(subList=>{
                setSubCategories(subList)
                    setFormData({
                        id: data.id,
                        name: data.name,
                        description: data.description,
                        categoryId: data.categoryId,
                        quantity: data.quantity,
                        unitPrice: data.unitPrice,
                        locationId: data.locationId,
                        barcode: data.barcode,
                        tag: data.tag,
                        statusId: data.statusId,
                        brand: data.brand,
                        model: data.model,
                        additionalNotes: data.additionalNotes,
                        dimensions: data.dimensions,
                        weight: data.weight,
                        unitOfWeightMeasurement: data.unitOfWeightMeasurement,
                        acquisitionDate: data.acquisitionDateInputFormatted,
                        userId: getUserId(),
                        subcategoryId: data.subcategoryId,
                        serialNumber: data.serialNumber,
                        partNumber: data.partNumber,
                        assignedToUserId: data.assignedToUserId,
                        differenceInQuantity: 0,
                        selectedStatuses: [],
                        selectedLocations: [],
                        selectedUsers: [],
                    });
                    setOldQty(data.quantity);
            })
            
        });
        
        // Cargar archivos existentes del item
        loadExistingFiles();
    },[]);
    return (
    <>
    <Row className='justify-content-center'>
        <Col xl={12}>
            <Form onSubmit={handleSubmit}>
                <Row className='' >
                        <Col>
                            <h3>Editar objeto</h3>
                        </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Nombre *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Descripción :</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="description"
                            value={formData.description}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Notas adicionales :</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            name="additionalNotes"
                            value={formData.additionalNotes}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={4} className=''  >
                            <Form.Label>Fecha de adquisición:</Form.Label>
                                <Form.Group controlId="formEmail">
                                <Form.Control
                                    type="date"
                                    name="acquisitionDate"
                                    placeholder=''
                                    value={formData.acquisitionDate}
                                    onChange={handleInputChange}                              
                                />
                        </Form.Group>
                    </Col>
                    <Col xl={4} >
                        <Form.Group controlId="">
                        <Form.Label>Cantidad de objetos *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col xl={4}>
                        <Form.Group controlId="">
                        <Form.Label>Costo unitario $:</Form.Label>
                        <Form.Control
                            type="text"
                            name="unitPrice"
                            placeholder='$'
                            value={formData.unitPrice}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="formRole">
                            <Form.Label>Categoría *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="categoryId"
                                value={formData.categoryId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar categoría</option>
                                {categories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <Form.Group controlId="formRole">
                            <Form.Label>Subcategoría:</Form.Label>
                            <Form.Control
                                as="select"
                                name="subcategoryId"
                                value={formData.subcategoryId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar subcategoría</option>
                                {subCategories.map((category) => (
                                        <option key={category.id} value={category.id}>{category.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="">
                            <Form.Label>Ubicación *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="locationId"
                                value={formData.locationId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar ubicación</option>
                                {locations.map((location) => (
                                        <option key={location.id} value={location.id}>{location.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                        <Form.Group controlId="">
                            <Form.Label>Estatus *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="statusId"
                                value={formData.statusId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Seleccionar el estatus del objeto</option>
                                {statuses.map((status) => (
                                        <option key={status.id} value={status.id}>{status.name}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Asignado a:</Form.Label>
                            <Form.Control
                                as="select"
                                name="assignedToUserId"
                                value={formData.assignedToUserId}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={0}>Sin asignar</option>
                                {users.map((user) => (
                                        <option key={user.id} value={user.id}>{user.userName} - {user.email}</option>
                                ))}
                            </Form.Control>
                        </Form.Group>                       
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Código de barras:</Form.Label>
                        <Form.Control
                            type="text"
                            name="barcode"
                            value={formData.barcode}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                    <Form.Group controlId="">
                        <Form.Label>Serial Number:</Form.Label>
                        <Form.Control
                        type="text"
                        name="serialNumber"
                        value={formData.serialNumber}
                        onChange={handleInputChange}
                        />
                    </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col>
                    <Form.Group controlId="">
                        <Form.Label>Part Number:</Form.Label>
                        <Form.Control
                        type="text"
                        name="partNumber"
                        value={formData.partNumber}
                        onChange={handleInputChange}
                        />
                    </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Etiqueta:</Form.Label>
                        <Form.Control
                            type="text"
                            name="tag"
                            value={formData.tag}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
    
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Marca:</Form.Label>
                        <Form.Control
                            type="text"
                            name="brand"
                            value={formData.brand}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Modelo:</Form.Label>
                        <Form.Control
                            type="text"
                            name="model"
                            value={formData.model}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col>
                        <Form.Group controlId="">
                        <Form.Label>Dimensiones *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="dimensions"
                            value={formData.dimensions}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='mt-3' >
                    <Col xl={6}>
                        <Form.Group controlId="">
                        <Form.Label>Peso *:</Form.Label>
                        <Form.Control
                            type="text"
                            name="weight"
                            value={formData.weight}
                            onChange={handleInputChange}            
                        />
                        </Form.Group>
                    </Col>
                    <Col xl={6}>
                    <Form.Group controlId="">
                            <Form.Label>Unidad de medida *:</Form.Label>
                            <Form.Control
                                as="select"
                                name="unitOfWeightMeasurement"
                                value={formData.unitOfWeightMeasurement}
                                onChange={handleInputChange}
                            >
                                <option key={0} value={null}>Seleccionar el estatus del objeto</option>
                                <option key={0} value="KG">KG</option>
                                <option key={0} value="LB">LB</option>
                               
                            </Form.Control>
                        </Form.Group>
                    </Col>
                </Row>
                
                {/* Sección de Archivos Adjuntos */}
                <Row className='mt-4'>
                    <Col>
                        <h5>Archivos Adjuntos</h5>
                    </Col>
                </Row>
                
                {/* Archivos Existentes */}
                <Row className='mt-3'>
                    <Col>
                        <Form.Label><strong>Archivos actuales:</strong></Form.Label>
                        {isLoadingFiles ? (
                            <div className="text-center mt-2">
                                <Spinner animation="border" size="sm" /> Cargando archivos...
                            </div>
                        ) : existingFiles.length > 0 ? (
                            <div className="border rounded p-3 mt-2">
                                {existingFiles.map((file) => (
                                    <Row key={file.id} className="mb-2 align-items-center">
                                        <Col xs={6}>
                                            <i className="bi bi-paperclip"></i> {file.name}
                                            <br />
                                            <small className="text-muted">
                                                {(parseFloat(file.size) / 1024).toFixed(2)} KB
                                            </small>
                                        </Col>
                                        <Col xs={6} className="text-end">
                                            <Button
                                                variant="info"
                                                size="sm"
                                                className="me-2"
                                                href={file.url}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <i className="bi bi-download"></i> Descargar
                                            </Button>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleDeleteFile(file.id, file.name)}
                                            >
                                                <i className="bi bi-trash"></i> Eliminar
                                            </Button>
                                        </Col>
                                    </Row>
                                ))}
                            </div>
                        ) : (
                            <div className="text-muted mt-2">
                                <i className="bi bi-inbox"></i> No hay archivos adjuntos
                            </div>
                        )}
                    </Col>
                </Row>
                
                {/* Agregar Nuevos Archivos */}
                <Row className='mt-3'>
                    <Col>
                        <Form.Group controlId="formFiles">
                            <Form.Label>Agregar nuevos archivos (opcional):</Form.Label>
                            <Form.Control
                                type="file"
                                multiple
                                accept=".jpg,.jpeg,.png,.gif,.webp,.pdf,.xls,.xlsx,.doc,.docx"
                                onChange={handleFileChange}
                            />
                            <Form.Text className="text-muted">
                                Formatos permitidos: Imágenes (JPG, PNG, GIF, WEBP), PDF, Excel (XLS, XLSX), Word (DOC, DOCX)
                            </Form.Text>
                        </Form.Group>
                        {selectedFiles.length > 0 && (
                            <div className="mt-2 border rounded p-2 bg-light">
                                <strong>Archivos seleccionados para subir:</strong>
                                <ul className="mb-0 mt-1">
                                    {selectedFiles.map((file, index) => (
                                        <li key={index}>
                                            {file.name} ({(file.size / 1024).toFixed(2)} KB)
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </Col>
                </Row>
                
                <Row className='justify-content-center mt-2'>
                    <Col xl={6} className='text-center'>
                        <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} >
                            Cancelar
                        </Button>
                        <Button className='m-3' variant="primary" type="submit">
                            Actualizar objeto
                        </Button>
                    </Col>
                    
                </Row>
            </Form>
        </Col>
    </Row>      
     <JustifyInventoryOutput
    show={showJustifyModal}
    handleClose={() => setShowJustifyModal(false)}
    differenceInQuantity={differenceInQuantity}
    selectedStatuses={selectedStatuses}
    setSelectedStatuses={setSelectedStatuses}
    selectedLocations={selectedLocations}
    setSelectedLocations={setSelectedLocations}
    selectedUsers={selectedUsers}
    setSelectedUsers={setSelectedUsers}
    onSave={handleSaveFromModal}
    setJustifyBy={setJustifyBy}
    justifyBy={justifyBy}
    isSaveDisabled={isSaveDisabled} 
    />
    
    <ConfirmModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={confirmDeleteFile}
        title="Eliminar archivo"
        message={`¿Estás seguro de eliminar el archivo "${fileToDelete.name}"? Esta acción es permanente y no se puede deshacer.`}
        confirmText="Eliminar"
        cancelText="Cancelar"
        variant="danger"
    />
      </>
    )
}
export default AddItem